import React, { useRef } from 'react';
import { Drawer, Flex, Tabs } from '@mantine/core';
import { IconHeadphones, IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import '@bobex/react-core/components/GenericSearch/searchForm.css';
import IncallTabContent from './IncallTabContent';
import SearchHeaderTabContent from '@/components/SearchHeader/SearchHeaderTabContent';

export type SearchDrawerTab = 'search' | 'incall';

interface SearchHeaderProps {
  isVisible: boolean;
  onClose: () => void;
  initialTab?: SearchDrawerTab;
}

export default function RightDrawer({
  isVisible,
  onClose,
  initialTab = 'search',
}: SearchHeaderProps) {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = React.useState<SearchDrawerTab>(initialTab);
  const companyInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    if (isVisible) setActiveTab(initialTab);
  }, [isVisible, initialTab]);

  return (
    <Drawer
      opened={isVisible}
      onClose={onClose}
      title={t('Tools')}
      position="right"
      size="sm"
      padding="md"
      withCloseButton
    >
      <Tabs
        keepMounted={false}
        value={activeTab}
        onChange={(v) => v && setActiveTab(v as SearchDrawerTab)}
        variant="default"
      >
        <Tabs.List grow>
          <Tabs.Tab value="search" leftSection={<IconSearch size={14} />}>
            {t('Search')}
          </Tabs.Tab>
          <Tabs.Tab value="incall" leftSection={<IconHeadphones size={14} />}>
            {t('Incall')}
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="search" pt="md" style={{ overflow: 'auto' }}>
          <SearchHeaderTabContent onClose={onClose} />
        </Tabs.Panel>
        <Tabs.Panel value="incall" pt="md" style={{ overflow: 'auto' }}>
          <Flex direction="column" gap="md" p="md">
            <IncallTabContent />
          </Flex>
        </Tabs.Panel>
      </Tabs>
    </Drawer>
  );
}
